import { render, staticRenderFns } from "./ripple-block.vue?vue&type=template&id=b1d767e2&"
import script from "./ripple-block.vue?vue&type=script&lang=ts&"
export * from "./ripple-block.vue?vue&type=script&lang=ts&"
import style0 from "./ripple-block.vue?vue&type=style&index=0&id=b1d767e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports